export enum NotificationEndpoints {
	UpdateNotificationsToRead = '/notifications/',
	UpdateNotificationToRead = '/notifications/:id',
	FetchNotifications = '/notifications',
	HasNotifications = '/notifications/has-notification'
}
